<h2>Deck Summary</h2>
<div class="wrapper">
    <div class="category" *ngFor="let item of summary | keyvalue">
        <h3>{{item.key}} ({{countType(item.key)}})</h3>
        <div [cardImageTooltip]="namesToCard[inner.key]" class="card-group" *ngFor="let inner of item.value | keyvalue" [class.invalid]="invalidCards.has(inner.key)" (click)="cardFor(item.key, inner.key)">
            <b>{{inner.value}}</b> {{inner.key}} <span *ngIf="invalidCards.has(inner.key)">*</span>
        </div>
    </div>
</div>
